/** Matches a 2-letter (or 2+2-letter) language code, e.g. "en", "pt", "zh-tw" */
export const LANG_CODE_REGEX = /^[a-z]{2}(-[a-z]{2})?$/;

/** Matches a language prefix at the start of a path, e.g. "/pt/" or "/pt" */
export const LANG_PATH_PREFIX_REGEX = /^\/([a-z]{2}(-[a-z]{2})?)(?:\/|$)/;

export const isLangCode = (segment: string): boolean =>
  LANG_CODE_REGEX.test(segment);
